import React from 'react';
import { Link } from 'react-router-dom';
import Loading from '../Loading';
import Manager from '../../Entities/Manager';
import Routes from './../../Shared/routes';


interface IProps {
    list: Manager[];
    error: string;
    remove: (newsCategoryId: number) => void;
    add: () => void;
    isLoading: boolean;
}

export default class ManagerList extends React.Component<IProps> {

    onAdd = () => {
        this.props.add();
    }

    renderItem = (item: Manager) => {
        return (
            <tr>
                <td>{item.getId()}</td>
                <td>{item.firstName} {item.lastName}</td>
                <td>{item.email}</td>
                <td>
                    <Link to={`${Routes.MANAGER_EDIT}${item.getId()}`}>Редактировать</Link><br />
                    <a href="#" onClick={() => this.props.remove(item.getId())}>Удалить</a>
                </td>
            </tr>
        )
    }


    render() {
        const { isLoading, list } = this.props;
        if (isLoading) {
            return <Loading />;
        }
        else {
            return (
                <>

                    <div className="app-title">
                        <div>
                            <h1><i className="fa fa-th-list"></i> Менеджеры</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-8">
                            <div className="tile">
                                <button
                                    onClick={this.onAdd}
                                    className="btn btn-primary"
                                    type="submit">Добавить менеджер</button>
                                <br />
                                <br />
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Имя</th>
                                            <th>Почта</th>
                                            <th>Действия</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {list.map(this.renderItem)}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </>
            )
        }
    }
}